<!-- Create private board per participant modal -->
<ng-container *ngIf="createMultiplePrivateBoards">
  <app-modal-template
    [title]="'Private board per participant' | translate"
    [size]="renderedAsMatBottomSheet ? pencilModalSizeEnum.FULL_WIDTH : pencilModalSizeEnum.SMALL"
    #privateBoardPerParticipantModal
    tabindex="0"
  >
    <div class="multiple-private-board-description" content-description>
      <span class="description-text">
        {{
          data.isModalForDuplicateBoard
            ? ('Who should we duplicate these boards for?' | translate)
            : ('Who should we create these boards for?' | translate)
        }}
      </span>
      <div class="options-container">
        <div class="dropdown-container">
          <app-pencil-drop-down-button
            [options]="createPrivateBoardsOptions"
            [selectedOption]="selectedOption"
            [disabled]="reachedMaxFoldersLimit"
            (selectionChange)="onCreatePrivateBoardsSelectionChange($event)"
          >
          </app-pencil-drop-down-button>
          <div class="participants-count">
            <svg-icon icon="people_outline" height="16" width="16"></svg-icon>
            <span class="participants-count-text"> {{ selectedParticipantsOptionCount }} </span>
          </div>
        </div>
        <ng-container *ngIf="reachedMaxBoardsCreationCount">
          <span class="warning-text">
            {{ 'You can only create boards for max {{count}} participants' | translate:{ count:
            MAX_BOARDS_CREATION_COUNT } }}
          </span>
        </ng-container>
        <ng-container *ngIf="!reachedMaxFoldersLimit && !selectedParticipantsOptionCount">
          <span class="warning-text">
            {{
              selectedOption?.id === ParticipantsOption.ONLINE_PARTICIPANTS_ONLY
                ? ('No online participants in Space' | translate)
                : ('No participants in Space' | translate)
            }}
          </span>
        </ng-container>
      </div>
    </div>
    <div class="actions-box" content-actions>
      <app-pencil-button
        theme="secondary"
        icon="close"
        [iconConfig]="{ type: IconTypes.matIcon }"
        [label]="'Cancel' | translate"
        (clickEvent)="close(false)"
      ></app-pencil-button>
      <div
        [appTooltip]="maxFoldersLimitTooltip"
        [appTooltipDisabled]="!reachedMaxFoldersLimit"
        [appTooltipPlacement]="'bottom-center'"
        class="w-100"
      >
        <app-pencil-button
          theme="primary"
          icon="check"
          [iconConfig]="{ type: IconTypes.matIcon }"
          [label]="'Confirm' | translate"
          [disabled]="shouldDisableCreatePrivateBoards"
          (clickEvent)="handleConfirmCreateMultiplePrivateBoards()"
        ></app-pencil-button>
      </div>
    </div>
  </app-modal-template>
</ng-container>

<ng-template #maxFoldersLimitTooltip>
  <app-tooltip
    text="{{ 'You’ve reached the max folder limit for this Space' | translate }}"
    arrow="top"
  ></app-tooltip>
</ng-template>

<!-- Create private board -->
<ng-container *ngIf="!createMultiplePrivateBoards">
  <app-modal-template
    [title]="
      data.isModalForDuplicateBoard
        ? ('Duplicate as private board' | translate)
        : ('Create private board' | translate)
    "
    [size]="
      (renderedAsMatBottomSheet | async)
        ? pencilModalSizeEnum.FULL_WIDTH
        : pencilModalSizeEnum.MEDIUM
    "
    [hasCloseButton]="true"
    [showActionsDivider]="true"
    (closeButtonClicked)="close()"
    [class]="'create-private-board-modal'"
    [class.bottom-sheet]="renderedAsMatBottomSheet | async"
  >
    <div class="description" content-description>
      <div class="description-header">
        <span>{{ 'Only hosts and selected participants can access this board.' | translate }}</span>
      </div>
      <app-participants-selection-list
        [privateUsersForFrame]="selectedFrame.privateUsers"
        (participantSelectionChange)="handleParticipantsSelectionChange($event)"
      >
      </app-participants-selection-list>
    </div>
    <div class="actions-box" content-actions>
      <div class="access-modal-actions">
        <app-pencil-button
          theme="secondary"
          class="cancel-button"
          icon="close"
          [iconConfig]="{ type: IconTypes.matIcon }"
          [label]="'Cancel' | translate"
          (clickEvent)="close()"
        ></app-pencil-button>
        <app-pencil-button
          theme="primary"
          class="confirm-button"
          icon="check"
          [iconConfig]="{ type: IconTypes.matIcon }"
          [label]="'Confirm' | translate"
          (clickEvent)="handleConfirmCreatePrivateBoard()"
        ></app-pencil-button>
      </div>
    </div>
  </app-modal-template>
</ng-container>
